export const PDF_NAME = 'LUCIOLE_PORFOLIO_SANTE_2026.pdf';
export const PDF_NAME_MOBILE = 'LUCIOLE_PORFOLIO_SANTE_2026.pdf';
export const PDF_NAME_HR = 'LUCIOLE_PORFOLIO_SANTE_2026_20260703.pdf';

export const SKIP_ANIMATION_STORAGE_KEY = 'SKIP_ANIMATION';

export const MENU_DESKTOP_WIDTH = 300;
export const MENU_MOBILE_HEADER_HEIGHT = 85;
export const MENU_MOBILE_FOOTER_HEIGHT = 75;
export const NAVIGATION_HEIGHT = 52;
export const MOBILE_NAVIGATION_HEIGHT = 40;
export const PDF_PAGE_RATIO = 339 / 190;
export const MODE_SINGLE_PAGE = false;
export const TITLE_LOADER = 'LUCIOLE';
export const PRESENTATION_TEXT = "Informer, sensibiliser, mobiliser. Nous accompagnons les acteurs de la santé dans la conception de communications claires, utiles et porteuses de sens.";
export const DOWNLOAD_TEXT = 'Télécharger ce portfolio';
export const SHARE_TEXT = 'Partager ce portfolio';
export const SHARE_TEXT_FACEBOOK = 'Partager sur Facebook';
export const SHARE_TEXT_X = 'Partager sur X';
export const SHARE_TEXT_LINKEDIN = 'Partager sur LinkedIn';
export const SHARE_TEXT_COPYPASTE = 'Copier le lien dans le presse-papier';
export const SHARE_TEXT_COPYPASTE_SUCCESS = 'Lien copié dans le presse papier';

export const FOLLOW_TEXT = 'NOUS SUIVRE';

export const TEXT_GROUPS = [
  {
    pages: [4, 5, 6, 7, 8],
    client: "AGENCE DE LA BIOMÉDECINE",
    secteur: "Santé publique",
    miles: "",
  },
  {
    pages: [9, 10, 11],
    client: "UNICANCER",
    secteur: "Lutte contre le cancer",
    miles: "",
  },
  {
    pages: [12, 13, 14, 15, 16],
    client: "SANTÉ PUBLIQUE FRANCE",
    secteur: "Agence nationale de santé publique",
    miles: "",
  },
  {
    pages: [17, 18, 19],
    client: "ARS",
    secteur: "Agence nationale de santé publique",
    miles: "",
  },
  {
    pages: [20, 21, 22, 23],
    client: "HÔPITAL NATIONAL DES 15-20",
    secteur: "Ophtalmologie",
    miles: "",
  },
  {
    pages: [24, 25, 26],
    client: "HEALTH DATA HUB",
    secteur: "Plateforme nationale de données de santé",
    miles: "",
  },
  {
    pages: [27, 28, 29, 30, 31],
    client: "WHAT’S UP DOC",
    secteur: "Magazine dédié aux jeunes médecins",
    miles: "",
  },
  {
    pages: [32, 33, 34, 35, 36, 37, 38],
    client: "ELSAN",
    secteur: "2<sup>ème</sup> groupe d'hospitalisation privée en France",
    miles: "",
  },
  {
    pages: [39, 40, 41, 42],
    client: "MEDECINES PATENT POOL",
    secteur: "Organisation internationale engagée dans la santé publique",
    miles: "",
  },
  {
    pages: [43, 44, 45],
    client: "HAUTE AUTORITÉ DE SANTÉ",
    secteur: "Santé publique",
    miles: "",
  },
  {
    pages: [46, 47, 48, 49],
    client: "ANSES",
    secteur: "Évaluation des risques sanitaires, veille scientifique et appui à la décision publique",
    miles: "",
  },
  {
    pages: [50, 52, 53, 54, 55, 56, 57, 58],
    client: "À PROPOS DE LUCIOLE",
    secteur: "",
    miles: "",
  },
];

const createTextLinks = (groups) => groups.reduce((acc, { pages, ...content }) => {
  pages.forEach((page) => {
    acc[page] = { ...content };
  });
  return acc;
}, {});

export const TEXT_LINKS = createTextLinks(TEXT_GROUPS);

export const PDF_MENU = [
  {
    label: 'AGENCE DE LA BIOMÉDECINE',
    pages: [4, 8],
  },
  {
    label: 'UNICANCER',
    pages: [9, 11],
  },
  {
    label: 'SANTÉ PUBLIQUE FRANCE',
    pages: [12, 16],
  },
  {
    label: 'ARS',
    pages: [17, 19],
  },
  {
    label: 'HÔPITAL NATIONAL DES 15-20',
    pages: [20, 23],
  },
  {
    label: 'HEALTH DATA HUB',
    pages: [24, 26],
  },
  {
    label: 'WHAT’S UP DOC',
    pages: [27, 31],
  },
  {
    label: 'ELSAN',
    pages: [32, 38],
  },
  {
    label: 'MEDECINES PATENT POOL',
    pages: [39, 42],
  },
  {
    label: 'HAUTE AUTORITÉ DE SANTÉ',
    pages: [43, 45],
  },
  {
    label: 'ANSES',
    pages: [46, 49],
  },
  {
    label: 'À PROPOS DE LUCIOLE',
    pages: [50, 58],
  },
];

export const LINKS = {
  37: {
    url: 'image111.gif',
    isGif: true,
  },
  41: {
    url: 'MPP_OUTRO.mp4',
    isVideo: true,
  },
}

export const WEB_LINKS = {
  11: {
    url: "https://unicancer.fr/rapport-activite/2024/",
  },
  57: {
    url: "https://luciole.com/projets/",
  },
}

const SHARE_URL = encodeURIComponent(window.location.href);
const SHARE_DESCRIPTION = encodeURIComponent('Luciole');
const SHARE_TITLE = encodeURI('Luciole');
export const WEBSITE_URL = 'https://luciole.com/';
export const FACEBOOK_SHARE_PARAMS = `http://www.facebook.com/share.php?u=${SHARE_URL}`;
export const X_SHARE_PARAMS = `http://x.com/intent/tweet?text=${SHARE_DESCRIPTION}&url=${SHARE_URL}`;
export const LINKEDIN_SHARE_PARAMS = ` https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}&title=${SHARE_TITLE}&summary=${SHARE_DESCRIPTION}`;
export const LINKEDIN_URL = 'https://www.linkedin.com/company/agence-luciole';

const CONFIG = {
  PDF_NAME,
  SKIP_ANIMATION_STORAGE_KEY,
  MENU_DESKTOP_WIDTH,
  MENU_MOBILE_HEADER_HEIGHT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_PAGE_RATIO,
  NAVIGATION_HEIGHT,
  LINKS,
  MOBILE_NAVIGATION_HEIGHT,
  FACEBOOK_SHARE_PARAMS,
  X_SHARE_PARAMS,
  WEBSITE_URL,
};

export default CONFIG;
